"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCEPTED_STATUS = exports.ASSIGNED_STATUS = exports.ALL_TASK_STATUSES = void 0;
exports.ALL_TASK_STATUSES = [0, 1, 2, 3, 4, 5];
exports.ASSIGNED_STATUS = 'Assigned';
exports.ACCEPTED_STATUS = 'Accepted';
//# sourceMappingURL=types.js.map